function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEBookDiscount = function SvgEBookDiscount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38 38"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25769"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17704",
    d: "M18 7.088v21.667m0-21.667A13.672 13.672 0 0 0 10.5 5 13.672 13.672 0 0 0 3 7.088v21.667a13.672 13.672 0 0 1 7.5-2.088 13.672 13.672 0 0 1 7.5 2.088m0-21.667A13.672 13.672 0 0 1 25.5 5 13.668 13.668 0 0 1 33 7.088v21.667a13.668 13.668 0 0 0-7.5-2.088 13.672 13.672 0 0 0-7.5 2.088",
    transform: "translate(1 2.122)",
    style: {
      strokeLinejoin: "round",
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 57036",
    transform: "translate(2947 -1697)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1141",
    transform: "translate(-2923.5 1713.5)",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeWidth: 3
    },
    d: "M6 0 0 6"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1881",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(-2925 1712)",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1882",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(-2919 1718)",
    style: {
      fill: "currentColor"
    }
  }))));
};

export default SvgEBookDiscount;